"use client";

import { c as _c } from "react/compiler-runtime";
import { ImageWell, SHOP_CATALOG_CARD_HEIGHT_CLASS_NAME, SHOP_SQUARE_CATALOG_CARD_HEIGHT_CLASS_NAME, priceForShopItem } from "../components/catalog-card-primitives";
import { getCatalogPromotionPresentation } from "../promotion-messaging";
import React from "react";
import { FiPlus } from "react-icons/fi";
import { GiftCardTile } from "@/components/billing/gift-card-tile";
import QuantityStepper from "@/components/ui/quantity-stepper";
import { useCatalogImageLayout } from "@/contexts/catalog-image-layout-provider";
import { formatCurrency } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { ShopItem, isCustomAmountGiftCard } from "@/types/shop";
import { giftCardShopDescription } from "./utils";
export const GiftCardShopTile: React.FC<{
  item: ShopItem;
  onSelect?: () => void;
  compact?: boolean;
  className?: string;
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
}> = t0 => {
  const $ = _c(50);
  const {
    item,
    onSelect,
    compact: t1,
    className,
    quantity,
    onQuantityChange
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const {
    catalogImageLayout
  } = useCatalogImageLayout();
  let t2;
  if ($[0] !== item) {
    t2 = item.imageUrl ? <ImageWell item={item} /> : undefined;
    $[0] = item;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const artwork = t2;
  let price;
  let promotionContent;
  let t3;
  let tileClassName;
  if ($[2] !== artwork || $[3] !== catalogImageLayout || $[4] !== className || $[5] !== compact || $[6] !== item || $[7] !== onQuantityChange || $[8] !== onSelect || $[9] !== quantity) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      tileClassName = artwork ? catalogImageLayout === "SQUARE" ? cx("aspect-auto", SHOP_SQUARE_CATALOG_CARD_HEIGHT_CLASS_NAME) : "aspect-auto h-auto max-h-none" : compact ? cx("aspect-auto", SHOP_CATALOG_CARD_HEIGHT_CLASS_NAME) : "aspect-[1.586] h-auto max-h-none min-h-[220px]";
      if (isCustomAmountGiftCard(item)) {
        let t4;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <FiPlus className="h-4 w-4" />;
          $[14] = t4;
        } else {
          t4 = $[14];
        }
        t3 = <GiftCardTile name={item.name} description={item.description} artwork={artwork} price="Your amount" size="compact" tone="muted" descriptionClassName="line-clamp-6" icon={t4} onClick={onSelect} ariaLabel={`Choose ${item.name}`} aria-haspopup="dialog" className={cx(tileClassName, className)} />;
        break bb0;
      }
      const currentPrice = priceForShopItem(item);
      const originalPrice = item.originalPrice ?? item.price;
      let t4;
      if ($[15] !== item) {
        t4 = getCatalogPromotionPresentation(item);
        $[15] = item;
        $[16] = t4;
      } else {
        t4 = $[16];
      }
      const promotion = t4;
      price = <>{originalPrice > currentPrice && <span className="mr-2 text-caption text-primary-foreground/65 line-through">{formatCurrency(originalPrice)}</span>}{formatCurrency(currentPrice)}</>;
      let t5;
      if ($[17] !== onQuantityChange || $[18] !== promotion || $[19] !== quantity) {
        t5 = promotion && <p className="mt-2 text-caption text-primary-foreground/90" title={promotion.name}><span className="font-semibold">{promotion.benefit}</span><span>{promotion.kind === "available" ? ` · ${promotion.action}` : quantity === undefined || !onQuantityChange ? ` ${promotion.action}` : null}</span></p>;
        $[17] = onQuantityChange;
        $[18] = promotion;
        $[19] = quantity;
        $[20] = t5;
      } else {
        t5 = $[20];
      }
      promotionContent = t5;
      if (quantity === undefined || !onQuantityChange) {
        const t6 = `Select ${item.name} for ${formatCurrency(currentPrice)}`;
        const t7 = originalPrice > currentPrice ? `Originally ${formatCurrency(originalPrice)}` : null;
        const t8 = promotion ? `${promotion.benefit} ${promotion.action}` : null;
        let t9;
        if ($[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
          t9 = [t6, t7, t8].filter(Boolean);
          $[21] = t6;
          $[22] = t7;
          $[23] = t8;
          $[24] = t9;
        } else {
          t9 = $[24];
        }
        const ariaLabel = t9.join(". ");
        const t10 = item.name;
        let t11;
        if ($[25] !== item) {
          t11 = giftCardShopDescription(item);
          $[25] = item;
          $[26] = t11;
        } else {
          t11 = $[26];
        }
        t3 = <GiftCardTile name={t10} description={t11} price={price} size="compact" descriptionClassName="line-clamp-6" onClick={onSelect} ariaLabel={ariaLabel} aria-haspopup="dialog" artwork={artwork} className={cx(tileClassName, className)}>{promotionContent}</GiftCardTile>;
        break bb0;
      }
    }
    $[2] = artwork;
    $[3] = catalogImageLayout;
    $[4] = className;
    $[5] = compact;
    $[6] = item;
    $[7] = onQuantityChange;
    $[8] = onSelect;
    $[9] = quantity;
    $[10] = price;
    $[11] = promotionContent;
    $[12] = t3;
    $[13] = tileClassName;
  } else {
    price = $[10];
    promotionContent = $[11];
    t3 = $[12];
    tileClassName = $[13];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[27] !== className) {
    t4 = cx("group relative", className);
    $[27] = className;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  const t5 = item.name;
  let t6;
  if ($[29] !== item) {
    t6 = giftCardShopDescription(item);
    $[29] = item;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span aria-hidden={true} className="block h-[38px] w-[114px]" />;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== artwork || $[33] !== item.name || $[34] !== price || $[35] !== promotionContent || $[36] !== t6 || $[37] !== tileClassName) {
    t8 = <GiftCardTile name={t5} description={t6} price={price} size="compact" descriptionClassName="line-clamp-6" badge={t7} artwork={artwork} className={tileClassName}>{promotionContent}</GiftCardTile>;
    $[32] = artwork;
    $[33] = item.name;
    $[34] = price;
    $[35] = promotionContent;
    $[36] = t6;
    $[37] = tileClassName;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== item.name || $[40] !== onSelect) {
    t9 = onSelect && <button type="button" aria-label={`View ${item.name}`} aria-haspopup="dialog" className="absolute inset-0 z-10 rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background" onClick={onSelect} />;
    $[39] = item.name;
    $[40] = onSelect;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== onQuantityChange || $[43] !== quantity) {
    t10 = <div className="absolute bottom-4 right-4 z-20" onClick={_temp}><QuantityStepper value={quantity} onChange={onQuantityChange} className="border-primary-foreground/30 bg-background/95" /></div>;
    $[42] = onQuantityChange;
    $[43] = quantity;
    $[44] = t10;
  } else {
    t10 = $[44];
  }
  let t11;
  if ($[45] !== t10 || $[46] !== t4 || $[47] !== t8 || $[48] !== t9) {
    t11 = <div className={t4}>{t8}{t9}{t10}</div>;
    $[45] = t10;
    $[46] = t4;
    $[47] = t8;
    $[48] = t9;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  return t11;
};
function _temp(event) {
  return event.stopPropagation();
}